/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { getAppLanguage, initLanguage } from './app/app.i18n';

boot();

async function boot() {
  const appLang = getAppLanguage();
  await initLanguage(appLang);

  const { AppComponent, appConfig } = await import("./app/app.config");

  try {
    await bootstrapApplication(AppComponent, appConfig);
  } catch (err) {
    console.error(err);
  }
}